// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const teamValidationErrors = {
  status: {
    required: 'Takım durumu seçilmelidir.',
  },
} as const

const { status } = teamValidationErrors

export const teamStatuses = ['active', 'inactive', 'deleted'] as const

export const teamSearchSchema = adminListSearchSchema

export const changeTeamStatusSchema = z.object({
  status: z.enum(teamStatuses, {
    message: status.required,
  }),
})
